module.exports = __webpack_public_path__ + "static/media/janine.9f93657a.jpg";